// extracted by mini-css-extract-plugin
module.exports = {"EcosystemSection":"EcosystemSection_EcosystemSection___9V3O"};